import apiAutenticacao from '../../api/apiAutenticacao';
import { RootAppState } from '../store';
import { SessaoState } from '../reduxTypes';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction, logoutAction, updateEmpresaAction } from './sessaoActions';
import { useEffect } from 'react';

export const useSessao = (): [
  SessaoState,
  (login: string, senha: string) => Promise<void>,
  () => Promise<void>,
  () => Promise<void>
] => {
  const sessao = useSelector((state: RootAppState) => state.sessao);
  const dispatch = useDispatch();

  const login = async (login: string, senha: string) => {
    const sessao = await apiAutenticacao.login(login, senha);
    const action = loginAction(sessao);
    dispatch(action);
    localStorage.setItem('sessao', JSON.stringify(sessao));
  };

  const logout = async () => {
    const action = logoutAction();
    dispatch(action);

    localStorage.removeItem('sessao');
  };

  const revalidate = async () => {
    const stored = localStorage.getItem('sessao');
    if (!stored) return;

    const sessaoSalva = JSON.parse(stored) as SessaoState;

    const empresa = await apiAutenticacao.getEmpresaEdCliente();

    dispatch(updateEmpresaAction(empresa));

    const atualizado = { ...sessaoSalva, empresa };
    localStorage.setItem('sessao', JSON.stringify(atualizado));
  };

  return [sessao, login, logout, revalidate];
};

export const useClienteLogado = () => {
  const [sessao] = useSessao();
  return sessao.cliente;
};

export const useEmpresa = () => {
  const [sessao] = useSessao();
  return sessao.empresa;
};
